import {css} from "@isceco/widget-library2/external/lit";

export default css`
  .tile-wrapper {
    display: flex;
    height: 100%;
    width: 100%;
    flex-direction: column;
    justify-content: space-between;
  }

  .tile-card {
    height: 200px;
    width: 200px;
    cursor: pointer;
  }

  .tile-text > * {
    margin: 0
  }

  .tile-content {
    display: flex;
    justify-content: space-between;
    align-content: end;
  }

  .tile-count {
    font-size: 30px;
    align-self: end;
    margin-bottom: var(--isceco-space-200);
  }
`
